export { CommonCriteria } from './CommonCriteria';
